import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    getGeneratedBagQRTags,
    getAlGroupsForDropdown,
    getAllOperationEntitiesForDropDown,
    getOperationEntityOptionsByGroupForDropDown,
    GetCollectionPointsFilter,
    getCollectionPointOptionsFilter,
    updateStatus,
    getOperationEntitiesByGroupForDropDown,
    saveQRtags,
    markBagQRTagsAsPrinted,
    getOperationEntityShortCodesByGroup,
    getCollectionPointShortCodesByOperationEntity,
    getLastBagQRSequenceNo
};

async function getAlGroupsForDropdown() {
    var groupArray = [];

    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}
async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllEstateFilteredOperationEntityByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getOperationEntityOptionsByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllEstateFilteredOperationEntityByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = {
            name: item[1]["operationEntityName"],
            shortName: getShortName(item[1], [
                "operationEntityShortName",
                "estateShortName",
                "shortName",
                "shortCode",
                "operationEntityCode",
                "estateCode"
            ])
        };
    }
    return operationEntityArray;
}

async function getAllOperationEntitiesForDropDown(groupID) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function GetCollectionPointsFilter(operationEntityID) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointByOperationEntityId', 'operationEntityID=' + operationEntityID);

    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function getCollectionPointOptionsFilter(operationEntityID) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointByOperationEntityId', 'operationEntityID=' + operationEntityID);

    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = {
            name: item[1]["collectionPointName"],
            shortName: getShortName(item[1], [
                "collectionPointShortName",
                "divisionShortName",
                "shortName",
                "shortCode",
                "collectionPointCode",
                "divisionCode"
            ])
        };
    }
    return collectionPointArray;
}

async function getGeneratedBagQRTags(groupID, operationEntityID, collectionPointID) {
    const params = 'group=' + encodeURIComponent(groupID || '') +
        '&estate=' + encodeURIComponent(operationEntityID || '') +
        '&division=' + encodeURIComponent(collectionPointID || '');
    const res = await CommonGet('/api/BagQRPrint/GetBagQRTags', params);
    return Array.isArray(res) ? res : res.data;
}

async function updateStatus(cardUpdate, cardPrintFilter) {
    let printCard = {
        cardStatusUpdateModel: cardUpdate,
        GroupID: parseInt(cardPrintFilter.groupID),
        OperationEntityID: parseInt(cardPrintFilter.operationEntityID),
        CollectionPointID: parseInt(cardPrintFilter.collectionPointID),
    }

    const response = await CommonPost('/api/EmployeeCardManagement/UpdateEmployeeCardsToPrint', null, printCard);
    return response;
}

async function saveQRtags(data) {
    const qrTags = data.map((tag) => ({
        tagNo: tag.tagNo,
        groupID: tag.groupID,
        operationEntityID: tag.operationEntityID,
        collectionPointID: tag.collectionPointID,
        sequenceNo: tag.sequenceNo,
        createdBy: tag.createdBy,
        isActive: tag.isActive !== undefined ? tag.isActive : true,
        isPrint: tag.isPrint !== undefined ? tag.isPrint : false
    }));
    const response = await CommonPost('/api/BagQRPrint/SaveBagQRtags', null, qrTags);
    return response
}

function getShortName(data, keys) {
    for (const key of keys) {
        if (data[key]) {
            return data[key];
        }
    }
    return "";
}

async function markBagQRTagsAsPrinted(collectionTagIDs, modifiedBy) {
    const payload = {
        collectionTagIDs: collectionTagIDs,
        modifiedBy: modifiedBy
    };
    const response = await CommonPost('/api/BagQRPrint/MarkBagQRTagsAsPrinted', null, payload);
    return response;
}

async function getOperationEntityShortCodesByGroup(groupID) {
    var response = await CommonGet('/api/BagQRPrint/GetOperationEntityShortCodesByGroup', 'groupID=' + groupID);
    return Array.isArray(response) ? response : response.data;
}

async function getCollectionPointShortCodesByOperationEntity(operationEntityID) {
    var response = await CommonGet('/api/BagQRPrint/GetCollectionPointShortCodesByOperationEntity', 'operationEntityID=' + operationEntityID);
    return Array.isArray(response) ? response : response.data;
}

async function getLastBagQRSequenceNo(groupID, operationEntityID, collectionPointID) {
    const params = 'groupID=' + encodeURIComponent(groupID) +
        '&operationEntityID=' + encodeURIComponent(operationEntityID) +
        '&collectionPointID=' + encodeURIComponent(collectionPointID);
    const res = await CommonGet('/api/BagQRPrint/GetLastBagQRSequenceNo', params);
    return typeof res === 'number' ? res : res.data;
}
